import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "slug", "fullUrl"]
  static values = { baseUrl: String }

  connect() {
    this.update()
  }

  update() {
    const value = this.inputTarget.value
    const slug = this.generateSlug(value)

    // Update slug text if we have a slug target (registration form)
    if (this.hasSlugTarget) {
      this.slugTarget.textContent = slug || "your-company"
    }

    // Update full URL if we have that target (settings page)
    // URL format is: http://host/{slug}/book
    if (this.hasFullUrlTarget && slug) {
      const baseUrl = this.fullUrlTarget.value.replace(/\/[^/]+\/book$/, "")
      this.fullUrlTarget.value = `${baseUrl}/${slug}/book`
    }
  }

  generateSlug(value) {
    if (!value || value.trim() === "") return ""

    return value
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
  }
}
